import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ServicesCardsComponent } from './components/services-cards/services-cards.component';

import { CarouselComponent } from './components/carousel/carousel.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { HeaderComponent } from './layouts/header/header.component';
import { NavComponent } from './layouts/nav/nav.component';
import { NeedhelpComponent } from './layouts/needhelp/needhelp.component';
import { BackToHomeComponent } from './components/back-to-home/back-to-home.component';
import { NotificationsCardsComponent } from './components/notifications-cards/notifications-cards.component';
import { ButtonLoginPingComponent } from './components/button-login-ping/button-login-ping.component';
import { ButtonLoginGovComponent } from './components/button-login-gov/button-login-gov.component';
import { TruncatePipe } from '../core/shared/pipes/truncate.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { EndSessionNotificationComponent } from './components/end-session-notification/end-session-notification.component';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { PermissionTableComponent } from './components/permission-table/permission-table.component';
import { MatTableModule } from '@angular/material/table';
import { ModalComponent } from './components/modal/modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTreeModule } from '@angular/material/tree';
import { TreeCheckboxComponent } from './components/tree-checkbox/tree-checkbox.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { GenericCardComponent } from './components/generic-card/generic-card.component';
import { InputCpfComponent } from './components/input-cpf/input-cpf.component';
import { InputEmailComponent } from './components/input-email/input-email.component';
import { InputInstitutionComponent } from './components/input-institution/input-institution.component';
import { InputNameComponent } from './components/input-name/input-name.component';
import { ModalFaleConoscoComponent } from './components/modal-fale-conosco/modal-fale-conosco.component';

@NgModule({
  declarations: [
    ServicesCardsComponent,
    FooterComponent,
    CarouselComponent,
    HeaderComponent,
    NavComponent,
    ModalFaleConoscoComponent,
    NeedhelpComponent,
    BackToHomeComponent,
    NotificationsCardsComponent,
    ButtonLoginPingComponent,
    ButtonLoginGovComponent,
    TruncatePipe,
    LoadingComponent,
    EndSessionNotificationComponent,
    PermissionTableComponent,
    ModalComponent,
    InputInstitutionComponent,
    InputNameComponent,
    InputCpfComponent,
    InputEmailComponent,
    TreeCheckboxComponent,
    SnackbarComponent,
    ConfirmModalComponent,
  ],
  exports: [
    CarouselComponent,
    FooterComponent,
    ServicesCardsComponent,
    HeaderComponent,
    NavComponent,
    ModalFaleConoscoComponent,
    NeedhelpComponent,
    BackToHomeComponent,
    NotificationsCardsComponent,
    ButtonLoginPingComponent,
    ButtonLoginGovComponent,
    LoadingComponent,
    EndSessionNotificationComponent,
    InputInstitutionComponent,
    PermissionTableComponent,
    ModalComponent,
    InputNameComponent,
    InputCpfComponent,
    InputEmailComponent,
    TreeCheckboxComponent,
    SnackbarComponent,
    ConfirmModalComponent,
    GenericCardComponent,
    TruncatePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgbCarouselModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTableModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatTreeModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatIconModule,
    MatSnackBarModule,
	GenericCardComponent
  ]
})
export class SharedModule { }
